import {
  DescriptionOutlined as DocsIcon,
  Language as WebIcon,
} from "@mui/icons-material";
import { alpha, Stack, Tooltip, Typography } from "@mui/material";

// One value with the source it came from, and whether that source is the one that
// counted. Shared by the triage report and the carry-forward review page so a field's
// provenance reads the same in both.
const SourcedValue = ({ source, value, governed, sx }) => {
  const Icon = source === "web" ? WebIcon : DocsIcon;
  return (
    <Stack direction={"row"} alignItems={"center"} spacing={0.5} sx={sx}>
      <Tooltip
        title={
          source === "web"
            ? governed
              ? "From the web — this is the value used"
              : "From the web — not used"
            : governed
            ? "From the documents — this is the value used"
            : "From the documents — not used"
        }
        arrow
      >
        <Icon
          sx={{
            fontSize: "0.78rem",
            color: governed ? "success.main" : "text.disabled",
            flexShrink: 0,
          }}
        />
      </Tooltip>
      <Typography
        component={"span"}
        noWrap
        sx={(theme) => ({
          px: "6px",
          py: "1px",
          borderRadius: "4px",
          bgcolor: governed
            ? alpha(theme.palette.text.primary, 0.05)
            : "transparent",
          border: `1px solid ${
            governed ? theme.palette.divider : "transparent"
          }`,
          fontFamily: "monospace",
          fontSize: "11.5px",
          color: governed ? "text.primary" : "text.secondary",
          fontWeight: 400,
          minWidth: 0,
        })}
      >
        {value}
      </Typography>
    </Stack>
  );
};

export default SourcedValue;
